// Prewritten "while you wait" lessons shown during book creation (no AI). Edit freely.
export const LEARN_SLIDES = [
  { title: "What your book credit includes", points: [
    "The complete book, its cover and full access to the book editor.",
    "Print-ready Amazon KDP interior PDF and cover PDF (with bleed and the right spine width).",
    "One ZIP package with everything, plus a README with step-by-step publishing instructions.",
    "Editable manuscript files (DOCX and EPUB) that you can re-download any time."] },
  { title: "Choosing a book size", points: [
    "6 × 9 in is the most common size for novels, memoirs and non-fiction.",
    "8.5 × 11 in suits workbooks, puzzle books, coloring books and large-print activity books.",
    "8.5 × 8.5 in works well for children's picture books.",
    "Pick the same size in KDP that you chose in KLYR, or the files won't match."] },
  { title: "How Cover Studio works", points: [
    "Open Cover Studio from your finished book to see alternative layouts of your cover.",
    "Tap any design to compare it side by side with your current cover, including at Amazon thumbnail size.",
    "Every cover you've had is saved; you can switch back any time for free.",
    "A red “Not print-ready” label means that layout would be rejected for paperback; it's still fine for ebooks."] },
  { title: "Publishing on Amazon KDP: the paperback", points: [
    "In KDP, choose Create → Paperback and fill in the title, author and description from your README.",
    "Under Manuscript, upload the interior PDF from your ZIP; under Book Cover, choose “Upload a cover you already have” and upload the cover PDF.",
    "Match the trim size to the one in your file names and choose WHITE paper (the spine and cover are calculated for white paper).",
    "Use KDP's Previewer to check every page before you publish."] },
  { title: "Publishing on Amazon KDP: the ebook", points: [
    "Choose Create → Kindle eBook and upload the EPUB from your ZIP as the manuscript.",
    "KDP also asks for a separate ebook cover image: download the front cover from your book's Downloads.",
    "Copy your Amazon description from the README and the keyword ideas from your book's Marketing kit into KDP.",
    "KDP usually takes up to 72 hours to review a new title."] },
  { title: "Credits and your account", points: [
    "One credit makes one complete book. Credits never expire.",
    "Buy 3 or more at once and every book in the order gets the lower price: $40 each, down to $35 each at 18+.",
    "Your credit balance and payment history (with receipts) are under Account.",
    "If a book fails to generate, its credit is returned automatically."] },
];
